import { OrganizationUserBulkPublicKeyResponse } from "@bitwarden/admin-console/common";

export class ProviderUserBulkPublicKeyResponse extends OrganizationUserBulkPublicKeyResponse {}
